export enum HealthDataPointType {
  quantity = 'quantity',
  category = 'category',
  correlation = 'correlation',
}
